import React, { Component } from 'react';
import { connect } from 'react-redux';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import GlobalFilterPanel, { FIELDS as GlobalFilterPanelFields } from '../filter/GlobalFilterPanel';

const log = new Logger('VAT_CODE_FILTER_PANEL', LOG_LEVELS.DEBUG);

export class VatCodesFilterPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selection: {}
    };
    this.handleChangeVATCodes = this.handleChangeVATCodes.bind(this);
    this.handleChangeCountryCodes = this.handleChangeCountryCodes.bind(this);
    this.onSearchClickHandler = this.onSearchClickHandler.bind(this);
  }

  onSearchClickHandler(selection) {
    log.clearAllDictionaryErrors();
    log.debug('onSearchClickHandler(): state.selection: ', this.state.selection);
    log.debug('onSearchClickHandler(): selection: ', selection);    
    let combinedSelection = Object.assign({}, this.state.selection, selection);  
     // Convert 'All' or '-1' to number -1 for the API
     if (combinedSelection.companyId === 'All') {
      combinedSelection.companyId = -1;
    }
    log.debug('onSearchClickHandler(): combinedSelection: ', combinedSelection);
    this.props.onSearch(combinedSelection);
  }

  onCompanySelectionHandler() {
    log.clearAllDictionaryErrors();
  }

  handleChangeVATCodes(evt) {
    log.clearAllDictionaryErrors();
    let selection = Object.assign({}, this.state.selection);
    selection.vatCode = evt.target.value;
    this.setState({ selection: selection});
  }

  handleChangeCountryCodes(evt) {
    log.clearAllDictionaryErrors();
    let selection = Object.assign({}, this.state.selection);
    selection.filterCountryCodes = evt.target.value;
    this.setState({ selection: selection});
  }

  render() {
    log.debug('render: ', this.props);
    const selection = this.state.selection;
    const extraOptions = [ {value:'Generic', body:'Generic'} ];
    let fieldOptions = {};
    fieldOptions[GlobalFilterPanelFields.PARAM_COMPANY_ID] = {
      useCompanyCode: true,
      customOptions: extraOptions,
      labelLanguageString: 'vatCodes_filter_company'
    };
    const hideElements = {};
    hideElements[GlobalFilterPanelFields.PARAM_COUNTRY_CODE] = true;
    hideElements[GlobalFilterPanelFields.PARAM_MONTH] = true;
    hideElements[GlobalFilterPanelFields.PARAM_YEAR] = true;
    hideElements[GlobalFilterPanelFields.PARAM_START_DATE] = true;
    hideElements[GlobalFilterPanelFields.PARAM_END_DATE] = true;
    hideElements[GlobalFilterPanelFields.PARAM_RETURN_TYPE] = true;
    hideElements[GlobalFilterPanelFields.PARAM_RETURN_STATUS] = true;

    let globalFilterPanelSetting = {
      searchLabelLanguageString: 'vatCodes_filter_button_filter',
      fieldOptions: fieldOptions,
      hideElements: hideElements,
      onSearchClick: this.onSearchClickHandler,
      atLeastOneRequired: false,
      onFieldChange: this.onCompanySelectionHandler,
    };
    // Enabling feature flag in 'All' company search functionality
    if (this.props.enableAllCompanySearchInVatCodeReport) {
      globalFilterPanelSetting.companySelectValueLanguageStringKey = "global_All";
    }
    return (
      <s-box name="filter-panel" class="mb20">
        <GlobalFilterPanel {...globalFilterPanelSetting}>
          <fieldset>
            <label><LanguageStringResolver string='vatCodes_filter_vatCodes'/></label>
            <input className="full-width" onChange={this.handleChangeVATCodes} placeholder="Enter VAT codes to search. (Example: ITPL220I;ITQL220I;...)" value={selection.vatCode} />
          </fieldset>
          <fieldset>
            <label><LanguageStringResolver string='vatCodes_filter_countryCodes'/></label>
            <input className="full-width" onChange={this.handleChangeCountryCodes} placeholder="Enter country codes to search. (Example: BE;GB;NL;...)" value={selection.countryCode} />
          </fieldset>
        </GlobalFilterPanel>
        <div className="clear"></div>
      </s-box>
    )
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps: ', state, props);
  return {
    enableAllCompanySearchInVatCodeReport: state.featureFlag?.data?.EnableAllCompanySearchInVatCodeReport
  };
}


VatCodesFilterPanel.defaultProps = {
  onSearch: () => {}
};

// Wrap the component to inject state into it
export default connect(mapStateToProps)(VatCodesFilterPanel);
